//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      img: [
        '../../static/imageother/home/index_tab_home_default.png',
        '../../static/imageother/home/index_tab_plice_default.png',
        '../../static/imageother/home/index_tab_list_default.png',
        '../../static/imageother/home/index_tab_user_default.png',
        '../../static/imageother/home/index_tab_people_default.png'
      ],
      activeImg: [
        '../../static/imageother/home/index_tab_home_selected.png',
        '../../static/imageother/home/index_tab_plice_selected.png',
        '../../static/imageother/home/index_tab_list_selected.png',
        '../../static/imageother/home/index_tab_user_selected.png',
        '../../static/imageother/home/index_tab_people_selected.png'
      ],
      // 添加设备
      showAddImg: true,
      showToast: false,
      showAddText: true,
      add: {
        deviceCode: '',
        devicephone: '',
        dname: '',
        relativeadd: ''
      },
      addWarn: false,
      warnText: '',
      showAdd: false,
      addText: '添加成功',
      host: '',
      // 提示
      hintShow: false,
      hintObj: ''
    }
  },
  created () {
    this.golobleObject.getHintOpen = this.getHintOpenShow
    this.host = window.location.host
  },
  methods: {
    getHintOpenShow (obj) {
      console.log(99, obj)
      this.hintObj = obj
      this.hintShow = true
    },
    loginOut () {
      let url = ''
      let host = window.location.host
      if (host === 'aimtycloud.anfangwx.aimtyiot.cn') { // 艾米安防云
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx78dc92678be7c2e6&redirect_uri=http%3A%2F%2Faimtycloud.anfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else if (host === 'anfangwxtest.aimtyiot.cn') { // 测试
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwxtest.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else {
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      }
      this.closeSub()
      if (this.isWx()) {
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        location.assign(url)
        this.hintShow = false
      } else {
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        this.$router.push('/')
        this.hintShow = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/Home.vue